import { scaleLinear, scaleOrdinal } from 'd3-scale';
import { calculateRange, calculateScaleDomain, getPaletteColor, } from '@keen.io/charts-utils';
var createScale = function (_a) {
    var data = _a.data, range = _a.range, key = _a.key;
    var _b = calculateRange(data, 'auto', 'auto', [key]), minimum = _b.minimum, maximum = _b.maximum;
    var scale = scaleLinear().domain([minimum, maximum]).range(range);
    calculateScaleDomain(scale, minimum, maximum);
    return {
        scale: scale,
        middlePoint: scale(maximum / 2),
    };
};
export var generateBubbles = function (_a) {
    var data = _a.data, margins = _a.margins, dimension = _a.dimension, colors = _a.colors, labelSelector = _a.labelSelector, disabledKeys = _a.disabledKeys, valueKey = _a.valueKey, xDomainKey = _a.xDomainKey, yDomainKey = _a.yDomainKey, minAreaRadius = _a.minAreaRadius, maxAreaRadius = _a.maxAreaRadius;
    var bubbles = [];
    var _b = createScale({
        data: data,
        key: xDomainKey,
        range: [margins.left, dimension.width - margins.right],
    }), xScale = _b.scale, xScalePoint = _b.middlePoint;
    var _c = createScale({
        data: data,
        key: yDomainKey,
        range: [dimension.height - margins.bottom, margins.top],
    }), yScale = _c.scale, yScalePoint = _c.middlePoint;
    var _d = calculateRange(data, 'auto', 'auto', [valueKey]), minimum = _d.minimum, maximum = _d.maximum;
    var radiusScale = scaleLinear()
        .domain([minimum, maximum])
        .range([minAreaRadius, maxAreaRadius]);
    data.forEach(function (item, idx) {
        var label = item[labelSelector];
        var color = getPaletteColor(idx, colors);
        if (disabledKeys && !disabledKeys.includes(label)) {
            var bubble = {
                key: label + "-" + idx,
                x: xScale(item[xDomainKey]),
                y: yScale(item[yDomainKey]),
                color: color,
                selector: [idx],
                radius: radiusScale(item[valueKey]),
            };
            bubbles.push(bubble);
        }
    });
    return {
        bubbles: bubbles.sort(function (a, b) { return b.radius - a.radius; }),
        xScale: xScale,
        yScale: yScale,
        middlePoint: [xScalePoint, yScalePoint],
    };
};
export var bubbleColorScale = function (colors) { return scaleOrdinal(colors); };
